import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {take} from 'rxjs/operators';
import {SnackBarService} from '@core/services/snack-bar.service';
import {IWorkflowCollectionState} from '@features/workflow/store/workflow.reducer';
import {Store} from '@ngrx/store';
import {
  CreateArrangementFromExistingCaseCommand,
  SyncParticipantsCommand,
  SyncProjectEntityToCompanyCommand
} from '@features/dac6-reporter/commands/dac6-reporter.command';
import {DialogModel} from "@shared/models/dialog.model";
import {DialogService} from "@shared/services/dialog-service";

@Injectable({
  providedIn: 'root',
})
export class CreateCaseCommandHandler  implements IPlatformCommandHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  activatedRoute: ActivatedRoute;
  magicLinkModelValueChanged: EventEmitter<any>;
  unSubscribe$ = new Subject<void>();
  constructor(
    private router: Router,
    private store: Store<IWorkflowCollectionState>,
    private fuseSplashScreenService: FuseSplashScreenService,
    private snackBarService: SnackBarService,
    private dialogService: DialogService,
    protected commandService: CommandService
  ) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any) {
    const dialogModel: DialogModel = DialogModel.create(
      'Create Case',
      'CreateCaseDialogComponent', {'caseType': command.fieldValues['CaseType'] === 'Case' ? 'PreArrangement' : command.fieldValues['CaseType'], disableTypeChange: command.fieldValues['CaseType'] !== 'Case'},
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        const caseInfo = {
          title: res.data.input.title,
          archiveExisting: false,
          existingCaseId: res.data.input.selectedCase
        };
        if (res.data.input.specifyField) {
          res.data.input.archiveExisting = false;
          this.openSelectFieldDialog(command, handler, res.data.input.selectedCase, res, res.data.input.selectedCase, res.data.input.caseType);
        } else {
          if (res.data.input.selectedCase) {
            this.addCaseFromExistingCaseId(command, handler, caseInfo, res.data.input.caseType);
          } else {
            this.addCase(command, handler, res.data.input.title, res.data.input.caseType);
          }
        }
      }
    });
    return true;
  }
  private openSelectFieldDialog(command: PlatformCommand, handler: IPlatformToolHandler, selectedCase: string, caseData: any, existingId: string, caseType: string) {
    const dialogModel: DialogModel = DialogModel.create(
      'Select Data',
      'VirtualGridDialogComponent', {
        sourceKey: 'Dac6-RowFieldData-Config',
        params: {
          'rowId': selectedCase,
          'dbmodelType': command.fieldValues['DbModel'],
          'sourceType': caseType
        }
      },
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        const caseInfo = {
          title: caseData.data.input.title,
          archiveExisting: caseData.data.input.archiveExisting,
          existingCaseId: existingId
        };
        this.addCaseFromExistingCaseId(command, handler, caseInfo, res.data.input.params.sourceType, res.data.input.selectedFields, false);
      }
    });
  }
  addCaseFromExistingCaseId(command: PlatformCommand, handler: IPlatformToolHandler, caseInfo: any, caseType, selectedFields?: string[], copyAllFields: boolean = true) {
    let commandName = command.fieldValues['CreateIndividualCaseFromExistingCaseCommand'];
    if(commandName.includes('[CASE_TYPE]')) commandName = commandName.replace('[CASE_TYPE]', caseType);
    const createCasecommand = new PlatformCommand(commandName, 'DAC6Api');
    createCasecommand.fieldValues['Title'] = caseInfo.title;
    createCasecommand.fieldValues['ExistingCaseId'] = caseInfo.existingCaseId;
    createCasecommand.fieldValues['ArchiveExisting'] = caseInfo.archiveExisting;
    createCasecommand.fieldValues['CopyCount'] = 1;
    createCasecommand.fieldValues['SelectedFields'] = selectedFields;
    createCasecommand.fieldValues['CopyAllFields'] = copyAllFields;
    createCasecommand.fieldValues['ForCorrection'] = false;
    handler.executeCommand(createCasecommand);
  }

  addCase(command: PlatformCommand, handler: IPlatformToolHandler, title: string, caseType) {
    let commandName = command.fieldValues['CreateIndividualCaseCommand'];
    if (commandName.includes('[CASE_TYPE]')) commandName = commandName.replace('[CASE_TYPE]', caseType);
    const createCasecommand = new PlatformCommand(commandName, 'DAC6Api');
    createCasecommand.fieldValues['Title'] = title;
    createCasecommand.waitForResponse = true;
    handler.executeCommand(createCasecommand);
  }
}
